/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentCashDto
 */
export interface NovitusPaymentCashDto {
    /**
     * Wartość płatności gotówką
     * @type {string}
     * @memberof NovitusPaymentCashDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentCashDto interface.
 */
export function instanceOfNovitusPaymentCashDto(value: object): value is NovitusPaymentCashDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentCashDtoFromJSON(json: any): NovitusPaymentCashDto {
    return NovitusPaymentCashDtoFromJSONTyped(json, false);
}

export function NovitusPaymentCashDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentCashDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function NovitusPaymentCashDtoToJSON(value?: NovitusPaymentCashDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

